import {View} from 'react-native'

import {atoms as a, useTheme} from '#/alf'
import {
  ContentFiltersFieldset,
  useShowContentFiltersFieldset,
} from '#/components/moderation/ContentFiltersFieldset'

export function SidebarContentFilters() {
  const t = useTheme()
  const show = useShowContentFiltersFieldset()

  if (!show) {
    return null
  }

  return (
    <View style={[a.p_lg, a.rounded_md, a.border, t.atoms.border_contrast_low]}>
      <ContentFiltersFieldset />
    </View>
  )
}
